import type { IconName } from "./iconData";

// The one glyph per tab, shared by mobile's bottom tabs (via its `tabIcon`
// factory) and web-rnw's narrow TabBar. Keyed by the tab's meaning, not by
// either platform's route key (mobile "Athletes" is web "coachDashboard").
export const TAB_ICON = {
  plan: "home",
  workouts: "dumbbell",
  progress: "chart",
  library: "list",
  athletes: "users",
  inbox: "inbox",
  debug: "search",
  me: "user",
  settings: "settings",
} as const satisfies Record<string, IconName>;
